/* eslint-env browser, jquery */
/* global Isotope */
import page from 'modules/ab-page-js';
import domify from 'domify';
import request from 'superagent';
import container from 'modules/section-content';
import Batch from 'batch';
import rg from 'modules/npm-component/require-global';
import metadata from './metadata.json';
import splash from './opensource-page.pug';

export default function register() {
  page('/opensource', loadScripts, repos, render);
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('//cdn.jsdelivr.net/isotope/2.0.0/isotope.pkgd.min.js', 'Isotope', done);
  });
  batch.end(next);
}

function repos(ctx, next) {
  ctx.repos = [];
  request.get('/opensource/repositories').end((err, res) => {
    if (err) return next();
    if (!res || !res.body || !res.body.length) return next();
    return (ctx.repos = res.body), next();
  });
}

function render(ctx, next) {
  const view = domify(splash({ repos: ctx.repos }));

  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view })
  };
  container.render(renderOptions);

  masonry();

  next();
}

function masonry() {
  const reposContainer = $('#repos')[0];
  const msnry = new Isotope(reposContainer, {
    // options
    itemSelector: '.repo-card-container',
    getSortData: {
      stars: '.stargazers_count parseInt'
    },
    sortAscending: false,
    sortBy: 'stars'
  });

  $('.masonry-nav ul li a').on('click', function(ev) {
    ev.preventDefault();

    const lang = $(this).attr('href').slice(1);

    $('.masonry-nav li').removeClass('active');
    $(this).parent('.masonry-nav li').addClass('active');

    const filterQuery = '[data-language%s]'.replace('%s', lang ? `=${lang}` : '');

    $(reposContainer).isotope({
      filter: filterQuery,
      getSortData: {
        stars: '.stargazers_count parseInt'
      },
      sortAscending: false,
      sortBy: 'stars'
    });
  });
}



// WEBPACK FOOTER //
// ./src/pages/opensource/opensource.js